import { useId, useState } from "react";
import { useIntl } from "react-intl";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import INotification from "../../../models/INotification";
import IUserUI from "../../../models/IUserUI";
import ISupplierModel from "../../../models/ISupplierModel";
import OwButton from "../../shared/OwButton/OwButton";
import OwTitle from "../../shared/OwTitle/OwTitle";
import CartCommissionBackfillPanel from "./CartCommissionBackfillPanel";
import "./CartCommissionBackfillModal.scss";

type Props = {
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    cancelFn: (refreshData?: boolean) => void;
};

/**
 * Hidden-feature admin tool (window.showHiddenFeatures) that drives POST /v1/cart/backfill-commissions.
 * The entry point in Orders.tsx is only rendered when the flag is on.
 */
export const CartCommissionBackfillModal = (props: Props) => {
    const intl = useIntl();
    const calendarPortalId = useId();
    const [locked, setLocked] = useState(false);

    return (
        <>
            <div className={"CartCommissionBackfillModal p-3"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle tag={"h4"} title={"backfill_cart_commissions"} />
                    <div>
                        <OwButton
                            disabled={locked}
                            className={"btn-danger"}
                            centerIconClass={"fas fa-times"}
                            ariaLabel={intl.formatMessage({ id: "close" })}
                            fn={() => {
                                props.cancelFn(false);
                            }}
                        />
                    </div>
                </div>
                <CartCommissionBackfillPanel
                    userModel={props.userModel}
                    supplierModel={props.supplierModel}
                    notifyFn={props.notifyFn}
                    onLockedChange={setLocked}
                    portalId={calendarPortalId}
                />
            </div>
            <div id={calendarPortalId} className="cart-commission-calendar-portal" />
        </>
    );
};
